import { supabase } from '../supabaseClient'
import { filasSync, type EstadoGuardado } from './sync-estados'

const TODOS_LOS_ITEMS_PRODUCTOS = ['GT-12', 'GT-13']

interface ProductForCompliance {
  id: string
  sds_url: string | null
}

export async function syncProductsCompliance(companyId: string): Promise<void> {
  if (!companyId) return

  const { data: products } = await supabase
    .from('products')
    .select('id, sds_url')
    .eq('company_id', companyId)
    .eq('status', 'active')

  const productList = (products ?? []) as ProductForCompliance[]

  let gt12Cumple = false
  let gt13Cumple = false
  // Si la lectura de sga_labels falla, GT-13 no se recalcula en esta pasada
  // (no se marca ni se revierte); GT-12 se evalúa igual.
  let gt13Evaluable = true

  if (productList.length > 0) {
    // GT-12: todos los productos activos tienen SDS accesible
    gt12Cumple = productList.every(p => !!p.sds_url && p.sds_url.trim() !== '')

    // GT-13: todos los productos activos tienen etiqueta SGA con PDF generado
    const productIds = productList.map(p => p.id)
    const { data: labels, error: labelsErr } = await supabase
      .from('sga_labels')
      .select('product_id, pdf_url')
      .in('product_id', productIds)

    if (labelsErr) {
      console.warn('products-compliance-sync: no se pudo leer sga_labels, GT-13 no se recalcula:', labelsErr)
      gt13Evaluable = false
    }

    const productosConEtiqueta = new Set(
      (labels ?? [])
        .filter((l: any) => !!l.pdf_url)
        .map((l: any) => l.product_id)
    )
    gt13Cumple = productosConEtiqueta.size === productList.length
  }

  const itemsAEvaluar = TODOS_LOS_ITEMS_PRODUCTOS.filter(id => id !== 'GT-13' || gt13Evaluable)

  const cumpleActual: string[] = []
  if (gt12Cumple) cumpleActual.push('GT-12')
  if (gt13Cumple) cumpleActual.push('GT-13')

  const { data: existing } = await supabase
    .from('checklist_item_estados')
    .select('item_id, estado, auto_source')
    .eq('company_id', companyId)
    .in('item_id', itemsAEvaluar)

  // Bloque 6, D: manda el módulo (sync-estados.ts): Cumple, En proceso si hay datos o Pendiente; nunca pisa un "No aplica".
  const rows = filasSync(companyId, itemsAEvaluar, cumpleActual, productList.length > 0 ? itemsAEvaluar : [], (existing ?? []) as EstadoGuardado[], 'productos')

  if (rows.length === 0) return

  await supabase.from('checklist_item_estados').upsert(rows, { onConflict: 'company_id,item_id' })
}
